export const normalizeCaseOption = (caseOption) => {
  if (!caseOption) {
    return null;
  }

  const id = caseOption?.id ?? caseOption?.pk ?? caseOption?.key ?? caseOption?.value;
  const label =
    caseOption?.label ?? caseOption?.value ?? caseOption?.client?.name ?? caseOption?.name ?? "";

  const clientData =
    caseOption?.client && caseOption?.client?.name ? caseOption.client : { name: label };

  return {
    ...caseOption,
    id,
    pk: caseOption?.pk ?? id,
    key: caseOption?.key ?? id,
    label,
    value: caseOption?.value ?? label,
    client: clientData,
  };
};

export const normalizeAssignableUserOption = (userOption) => {
  if (!userOption) {
    return null;
  }

  const id = userOption?.id ?? userOption?.pk ?? userOption?.key ?? userOption?.value;
  const label = userOption?.label ?? userOption?.value ?? userOption?.name ?? "";

  return {
    ...userOption,
    id,
    pk: userOption?.pk ?? id,
    key: userOption?.key ?? id,
    label,
    value: userOption?.value ?? label,
    name: userOption?.name ?? label,
  };
};

export const normalizeRoleOption = (roleOption) => {
  if (!roleOption) {
    return null;
  }

  const id = roleOption?.id ?? roleOption?.pk ?? roleOption?.key ?? roleOption?.value;
  const label = roleOption?.label ?? roleOption?.value ?? roleOption?.name ?? "";

  return {
    ...roleOption,
    id,
    pk: roleOption?.pk ?? id,
    key: roleOption?.key ?? id,
    label,
    value: roleOption?.value ?? label,
    name: roleOption?.name ?? label,
  };
};

export const normalizeLawFirmOption = (lawFirmOption) => {
  if (!lawFirmOption) {
    return null;
  }

  const id = lawFirmOption?.id ?? lawFirmOption?.pk ?? lawFirmOption?.key ?? lawFirmOption?.value;
  const label = lawFirmOption?.label ?? lawFirmOption?.value ?? lawFirmOption?.name ?? "";

  return {
    ...lawFirmOption,
    id,
    pk: lawFirmOption?.pk ?? id,
    key: lawFirmOption?.key ?? id,
    label,
    value: lawFirmOption?.value ?? label,
    name: lawFirmOption?.name ?? label,
  };
};
